<template>
  <div class="page-footer" :style="{ width: footerWidth }">
    <slot></slot>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount,defineProps } from 'vue'

const props = defineProps({
  contentRef: {
    type: String,
    default: 'app-main_bottom__content'
  }
})

const footerWidth = ref('0px')
const setFooterWidth = () => {
  const contentEl = document.querySelector(`.${props.contentRef}`)
  if (contentEl) {
    const contentWidth = contentEl.clientWidth
    footerWidth.value = contentWidth + 'px'
  }
}

onMounted(() => {
  const resizeObserver = new ResizeObserver(() => {
    setFooterWidth()
  })
  resizeObserver.observe(document.querySelector(`.${props.contentRef}`))
  onBeforeUnmount(() => {
    resizeObserver.disconnect()
  })
})


</script>

<style scoped lang="scss">
.page-footer {
  position: fixed;
  bottom: 0;
  right: 0;
  background-color: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);
  height: 50px;
  z-index: 2;
}
</style>